import { componentFormValidationSlice } from '@Store/slices/componentFormValidation';

export const {
  setDisabled,
  setSubDisabled,
  setStakeholderValidation,
  setStakeholderValidationSubNational,
  setWorkingAreasValidation,
} = componentFormValidationSlice.actions;
